/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { InstanceData } from "../../../../models/instance-data";
import { Component, Input, Output, EventEmitter } from "@angular/core";


@Component({
  selector: 'app-phone-number-editor',
  templateUrl: './phone-number-editor.component.html'
})
export class PhoneNumberEditorComponent {
  
  @Input()
  mData: InstanceData;
  
  @Output()
  removeClicked = new EventEmitter<void>();

  onPhoneChange(event: any): void {
	this.mData.object_value = event;
  }
  
}
